// CardRateQuery 卡片式运价查询模块国际化 - 中文
export default {
  // 搜索表单
  searchForm: {
    departurePort: '起运港',
    departurePortPlaceholder: '请选择起运港',
    dischargePort: '卸货港',
    dischargePortPlaceholder: '请选择卸货港',
    originCountry: '起运国家',
    originCountryPlaceholder: '请选择起运国家',
    originCity: '起运城市',
    originCityPlaceholder: '请选择起运城市',
    destinationCountry: '目的国家',
    destinationCountryPlaceholder: '请选择目的国家',
    destinationCity: '目的城市',
    destinationCityPlaceholder: '请选择目的城市',
    cargoReadyTime: '货好时间',
    cargoTimeMode: {
      range: '区间',
      date: '日期'
    },
    cargoTimeRange: {
      threeDays: '三天内',
      oneWeek: '一周内',
      twoWeeks: '二周内',
      oneMonth: '一个月内',
      twoMonths: '二个月内'
    },
    cargoDatePlaceholder: '请选择货好时间',
    search: '查询',
    reset: '重置',
    recentSearches: '最近搜索',
    filterSettings: '设置筛选',
    filterSettingsTitle: '设置筛选条件',
    filterSettingsOkText: '确定',
    filterSettingsCancelText: '取消',
    filterSettingsAvailable: '可选条件',
    filterSettingsAllAdded: '所有条件已添加',
    filterSettingsAdd: '添加',
    filterSettingsSelected: '已选条件',
    filterSettingsEmpty: '暂未选择筛选条件',
    moreFilters: '更多筛选'
  },

  // 工具栏
  toolbar: {
    containerType: '箱型',
    containerTypePlaceholder: '请选择箱型',
    shippingCompany: '船公司',
    shippingCompanyPlaceholder: '请选择船公司',
    transitType: {
      all: '全部',
      direct: '直达',
      transit: '中转'
    },
    sorting: {
      earliest: '最早',
      fastest: '最快',
      cheapest: '最便宜'
    },
    columnSettings: '设置列'
  },

  // 列设置弹窗
  columnSettings: {
    confirm: '确定',
    cancel: '取消',
    availableFields: '可选字段',
    allFieldsAdded: '所有字段已添加',
    add: '添加',
    selectedFields: '已选字段',
    noFieldsSelected: '暂未选择字段'
  },

  // 加载状态
  loading: {
    searching: '正在加载...',
    loadingMore: '正在加载更多数据...',
    failed: '加载失败，请稍后重试',
    retry: '重试',
    noMoreData: '已加载全部数据 (共 {count} 条)',
    scrollToLoadMore: '滚动到底部加载更多',
    scrollHint: '向下滚动加载更多'
  },

  // 空状态
  empty: {
    noData: '暂无数据，请调整搜索条件后重试'
  },

  // FCL 整箱运价卡片
  fclCard: {
    freightType: {
      contract: '合约价',
      spot: 'SPOT'
    },
    transitStatus: {
      direct: '直达',
      transit: '中转'
    },
    spaceStatus: {
      smooth: '畅接',
      singleApply: '单申',
      overbooked: '爆舱',
      notAccepting: '不接'
    },
    priceTrend: {
      rising: '上涨',
      falling: '下跌',
      stable: '平稳'
    },
    transitDays: '{days}天',
    priceUnit: '¥',
    headers: {
      carrier: '船公司',
      route: '起运港 / 卸货港',
      remarks: '备注信息',
      validity: '有效期',
      costTotal: '成本总价',
      sellTotal: '卖价总价',
      inquiryTotal: '询价总价',
      actions: '操作'
    },
    route: {
      placeOfReceipt: '收货地',
      placeOfDelivery: '目的港'
    },
    dataSource: {
      ecommerce: '电商',
      offline: '线下',
      cargoware: 'CargoWare'
    },
    shelf: {
      listed: '已上架',
      unlisted: '未上架'
    },
    recommend: {
      ecommerce: '电商运价'
    },
    laneCode: '航线：{code}',
    cargoName: '品名：{name}',
    remarks: {
      receivingInstructions: '接货特殊说明：',
      overweight: '超重说明：',
      freePeriod: '免箱免堆：',
      detentionFree: '目的港免用箱{days}天',
      demurrageFree: '目的港免堆存{days}天',
      note: '备注：',
      viewMore: '查看更多'
    },
    cargo: {
      type: '货物类型',
      description: '货物描述'
    },
    selectedSailings: '✓ 已选 {count} 个船期',
    rateOnly: '仅运价',
    actions: {
      viewDetail: '查看详情',
      costDetails: '费用明细',
      bookingNow: '立即订舱',
      viewTrend: '查看趋势',
      viewSailings: '查看船期',
      viewAvailableSailings: '查看可用船期'
    },
    tooltips: {
      transitRoute: '中转路线：{route}'
    },
    fields: {
      detentionFreeDays: '免费用箱期',
      demurrageFreeDays: '免费用港期'
    },
    periodTo: '至 {end}',
    periodFrom: '{begin} 起'
  },

  // 列表/卡片船期展开面板
  schedulePanel: {
    empty: '暂无匹配船期',
    moreSchedules: '更多船期',
    placeOrder: '下单',
    oceanFreight: '海运费',
    columns: {
      vessel: '船名',
      voyage: '航次',
      laneCode: '航线代码',
      svcInfo: 'SVC信息',
      svc: 'SVC',
      directTransit: '直达/中转',
      direct: '直达',
      transitPort: '中转港',
      transit: '中转',
      firstSvc: '头程SVC',
      secondSvc: '二程SVC',
      thirdSvc: '三程SVC',
      fourthSvc: '四程SVC',
      svcLeg: '{leg}程SVC',
      shareCabins: '共舱船',
      etd: 'ETD',
      eta: 'ETA',
      departureSchedule: '开航班期',
      customsCutoffSchedule: '截关班期',
      portCutoffTime: '截港时间',
      customsCutoffTime: '截关时间',
      declarationDeadline: '报关截止时间',
      action: '操作'
    }
  },

  // 拼箱运价卡片
  lclCard: {
    cbmPrice: 'CBM 单价',
    tonPrice: 'TON 单价',
    minCharge: '最低一票',
    cbmUnit: '/CBM',
    tonUnit: '/TON',
    minChargeUnit: '/票',
    actions: {
      viewSailings: '查看船期',
      bookingNow: '在线下单',
      viewDetail: '查看详情'
    },
    fields: {
      laneCode: '航线代码'
    },
    selectedSailings: '已选 {count} 个船期',
    scheduleNeedPorts: '请先维护起运港和目的港后再查看船期',
    scheduleLoadFailed: '船期加载失败',
    validFrom: '{date} 起',
    validUntil: '至 {date}'
  },

  // 空运运价卡片
  airCard: {
    nPrice: 'N价',
    minPrice: '最低收费',
    kgUnit: '/KG',
    perShipment: '/票起',
    tierM: 'M(最低)',
    tierN: 'N',
    tier45: '45+',
    tier100: '100+',
    tier300: '300+',
    tier500: '500+',
    tier700: '700+',
    tier1000: '1000+',
    tier2000: '2000+',
    supplier: '供应商',
    airline: '航空公司',
    validPeriod: '有效期',
    remarks: '备注',
    directFlight: '直飞',
    transitFlight: '中转',
    voyageDays: '{days}天',
    actions: {
      viewDetail: '查看详情',
      bookingNow: '在线下单'
    },
    validFrom: '{date} 起',
    validUntil: '至 {date}',
    flightQueryPending: '航班查询功能开发中...'
  },

  // 港前运价卡片
  precarriageCard: {
    supplier: '供应商',
    priceMethod: {
      perContainer: '按柜',
      perTon: '按吨',
      perCbm: '按方',
      direct: '直拖',
      branchLine: '支线',
      seaRail: '海铁'
    },
    transportMode: {
      truck: '拖车',
      barge: '驳船',
      rail: '铁路'
    },
    status: {
      normal: '正常',
      expired: '过期',
      disabled: '禁用'
    },
    transitDays: '{days}天',
    priceUnit: '¥',
    costPrice: '成本',
    actions: {
      viewDetail: '查看详情',
      bookingNow: '立即订舱'
    },
    periodTo: '至 {end}',
    periodFrom: '{begin} 起'
  },

  // 尾程运价卡片
  oncarriageCard: {
    agent: '代理',
    address: '地址',
    priceMethod: {
      perContainer: '按柜',
      perTon: '按吨',
      perCbm: '按方',
      direct: '直拖',
      branchLine: '支线',
      seaRail: '海铁'
    },
    branchLine: {
      rail: '铁路支线',
      truck: '卡车支线',
      barge: '驳船支线'
    },
    status: {
      normal: '正常',
      expired: '过期',
      disabled: '禁用'
    },
    transitDays: '{days}天',
    priceUnit: '$',
    actions: {
      viewDetail: '查看详情',
      bookingNow: '立即订舱'
    },
    addressFormat: {
      city: '{city}',
      stateCity: '{state}, {city}',
      fullAddress: '{address}'
    },
    periodTo: '至 {end}',
    periodFrom: '{begin} 起'
  },

  // 快递运价卡片
  expressCard: {
    firstWeight: '首重 {kg}kg',
    additionalWeight: '续重 /{kg}kg',
    minimum: '最低 {currency} {amount}',
    tierFrom: '{kg}kg起',
    tierCount: '共{count}段',
    surchargeCount: '附加费 {count}项',
    billingMode: {
      percentage: '百分比',
      fixed: '固定'
    },
    totalPerKg: '总价/kg',
    formulaTitle: '总价计费公式',
    stepChargeableWeight: '1. 计费重量',
    chargeableWeightFormula: '计费重 = MAX(实重, 体积重)',
    volumetricWeightFormula: '体积重 = L×W×H÷6000',
    stepFormula: '2. 公式',
    formulaFirstAdditional: '总价 = ((首重价格 + 续重价格 + 旺季附加费) × KG + 其它杂费) × (1 + 燃油附加费)',
    formulaUnitPrice: '总价 = ((单价 + 旺季附加费) × KG + 其它杂费) × (1 + 燃油附加费)',
    formulaWeightTier: '总价 = ((重量段价格 + 旺季附加费) × KG + 其它杂费) × (1 + 燃油附加费)',
    resultEquals: '结果 =',
    formulaNote: '总价按照1千克进行计算',
    packaging: '包装',
    volumetricFactor: '体积系数',
    validPeriod: '有效期',
    expired: '已失效',
    actions: {
      detail: '详情',
      linkOrder: '关联委托单'
    },
    source: {
      inquiry: '询价入库',
      bid: '招标入库',
      manual: '手工录入'
    },
    status: {
      normal: '正常',
      published: '正常',
      expired: '失效',
      disabled: '禁用',
      draft: '草稿'
    },
    serviceType: {
      express: '特快',
      standard: '标快',
      economy: '经济',
      priorityFreight: '优先货运',
      economyFreight: '经济货运',
      deferredFreight: '递延货运'
    },
    loadingMode: {
      express: '快递',
      ltl: '零担',
      ftl: '整车'
    },
    billingModel: {
      firstAdditional: '首重+续重',
      unitPrice: '单价计费',
      weightTier: '重量段阶梯'
    },
    packagingType: {
      envelope: '信封',
      parcel: '邮包',
      package: '包裹'
    },
    periodTo: '至 {end}',
    periodFrom: '{begin} 起'
  },

  railSearchForm: {
    departureStation: '起运站',
    departureStationPlaceholder: '请选择起运站',
    arrivalStation: '目的站',
    arrivalStationPlaceholder: '请选择目的站',
    railCompany: '铁路公司',
    railCompanyPlaceholder: '请选择铁路公司',
    transportMode: '运价类型',
    transportModePlaceholder: '请选择运价类型',
    transportModes: {
      container: '集装箱',
      truck: '整车',
      bulk: '散货'
    }
  },

  railCard: {
    transitDays: '{days}天',
    minPrice: '最低 {price}',
    actions: {
      viewDetail: '查看详情'
    },
    units: {
      tonKilometer: '吨公里',
      // 后端单位名匹配关键字（含历史中文单位名）
      tonKilometerMatch: '吨/公里|吨公里|ton/kilometer|ton/km|ton-km'
    },
    railCompanyCode: {
      cre: '中铁',
      kts: '哈铁',
      rzd: '俄铁',
      hkt: '中老泰',
      tsr: '西伯利亚'
    },
    fields: {
      containerOwner: '箱属',
      cargoType: '货物类型',
      routeType: '线路分类'
    },
    transportMode: {
      container: '集装箱',
      truck: '整车',
      bulk: '散货'
    },
    direction: {
      import: '进口',
      export: '出口',
      transit: '中转',
      outbound: '去程',
      inbound: '回程'
    },
    routeType: {
      direct: '直达',
      transfer: '中转',
      combined: '联运',
      middle: '中线',
      north: '北线',
      south: '南线',
      southeast: '东南亚',
      centralAsia: '中亚'
    },
    directTransit: {
      direct: '直达',
      transit: '中转'
    },
    status: {
      published: '已发布',
      draft: '草稿',
      expired: '已过期',
      disabled: '已禁用'
    },
    cargoType: {
      general: '普通货物',
      dangerous: '危险品',
      reefer: '冷藏',
      vehicle: '车辆'
    }
  },

  // 通用
  common: {
    containerTypes: {
      '20GP': '20GP',
      '40GP': '40GP',
      '40HC': '40HC',
      '45HC': '45HC',
      '20NOR': '20NOR',
      '40NOR': '40NOR'
    },
    noPrice: '询价',
    priceNotAvailable: '-',
    imageError: '图片加载失败',
    voyageDays: '{days}天',
    inquiryRequired: '电询',
    actions: {
      applySpecialPrice: '申请特价',
      applySpecialPriceShort: '申请特价'
    },
    messages: {
      specialPriceApplyPending: '特价申请弹窗将在后续模块接入'
    },
    currency: {
      usd: '$',
      cny: '¥',
      eur: '€'
    }
  },

  specialPriceApply: {
    title: '申请特价',
    sections: {
      rateInfo: '运价信息',
      basicInfo: '基础信息',
      priceDetail: '费用明细',
      surchargeDetail: '附加费明细',
      applicationInfo: '申请信息'
    },
    rateTypes: {
      fcl: '整箱',
      lcl: '拼箱',
      prePort: '港前',
      lastMile: '尾程',
      air: '空运',
      express: '快递',
      rail: '铁路'
    },
    lclDefaultItemName: '拼箱运费',
    fields: {
      rateType: '运价类型',
      rateNo: '运价编号',
      validPeriod: '有效期',
      origin: '起运',
      destination: '目的',
      carrier: '承运方',
      customer: '下单客户',
      cargoReadyDate: '预计货好时间',
      cargoType: '货物类型',
      quantity: '数量',
      volumeCbm: '体积 (CBM)',
      weightTon: '重量 (TON)',
      chargeableWeight: '计费重量',
      densityLevel: '指定密度阶级',
      currentTier: '当前重量档位',
      targetKgUnitPrice: '目标 KG 单价',
      targetMinCharge: '目标最低计费',
      containerQuantity: '数量',
      specifySchedule: '指定船期',
      schedule: '选择船期',
      vessel: '船名',
      voyage: '航次',
      laneCode: '航线代码',
      targetPrice: '目标价明细',
      currentPrice: '当前',
      reason: '申请原因',
      remark: '备注'
    },
    columns: {
      feeName: '费用项目',
      feeType: '费用类型',
      densityLevel: '密度等级',
      itemName: '费用项',
      currency: '币种',
      billingUnit: '计费单位',
      unitPrice: '单价',
      minCharge: '最低收费',
      maxCharge: '最高收费',
      paymentTerm: '付费条款',
      remark: '备注',
      feeSource: '费用来源',
      originalUnitPrice: '原单价',
      originalMinCharge: '原最低收费',
      quantity: '数量',
      targetUnitPrice: '目标单价',
      targetMinCharge: '目标最低收费',
      targetLclMinCharge: '目标最低一票'
    },
    fees: {
      oceanFreight: '海运费',
      baseRate: '基础运价',
      oceanSurcharge: '海运附加费',
      originSurcharge: '起运港附加费',
      destinationSurcharge: '目的港附加费'
    },
    units: {
      container: '个'
    },
    placeholders: {
      customer: '请选择下单客户',
      cargoReadyDate: '请选择预计货好时间',
      cargoType: '请选择货物类型',
      schedule: '请选择船名航次',
      quantity: '请输入数量',
      chargeableWeight: '请输入计费重量',
      densityLevel: '请选择密度阶级',
      targetUnitPrice: '请输入目标单价',
      targetMinCharge: '请输入目标最低收费',
      selectContainerQuantityFirst: '请先填写箱量',
      selectQuantityFirst: '请先填写数量',
      reason: '请输入申请原因',
      remark: '请输入备注'
    },
    paymentTerms: {
      prepaid: '预付',
      collect: '到付'
    },
    airFeeTypes: {
      origin: '起运地附加费',
      destination: '目的地附加费',
      mainline: '干线附加费'
    },
    feeSources: {
      manual: '用户创建',
      system: '系统匹配'
    },
    validation: {
      customerRequired: '请选择下单客户',
      cargoReadyDateRequired: '请选择预计货好时间',
      cargoReadyDateFuture: '预计货好时间必须晚于今天',
      cargoTypeRequired: '请选择货物类型',
      reasonRequired: '请输入申请原因',
      reasonTooLong: '申请原因不能超过 500 个字符',
      remarkTooLong: '备注不能超过 200 个字符',
      priceItemRequired: '请至少填写一条目标价明细',
      priceItemIncomplete: '目标价明细中的数量和目标单价必须同时大于 0',
      lclPriceItemIncomplete: 'CBM、TON 至少填写一项，并填写目标单价和目标最低一票',
      compositeQuantityRequired: '港前或尾程非箱型运价请至少填写体积或重量，并填写当前计费单位对应的数量',
      compositePriceAmbiguous: '港前或尾程非箱型运价存在多组基础计费单位或币种，无法使用单一目标价提交',
      targetPriceMustBeLower: '{itemName} 的目标单价必须低于原价 {originalUnitPrice}',
      targetMinChargeMustBeLower: '目标最低收费必须低于当前最低收费',
      currencyRequired: '目标价明细缺少币种，无法提交特价申请',
      currencyNotFound: '币种 {currency} 未匹配到基础数据，请先维护币种基础数据',
      scheduleRequired: '请选择船期',
      rateUnavailable: '当前运价不允许申请特价'
    },
    schedule: {
      helper: '如不指定，则按运价默认船期执行',
      enabled: '已开启指定',
      disabled: '不指定',
      matching: '正在匹配可用船期',
      noMatched: '未匹配到可用船期',
      reload: '重新匹配'
    },
    actions: {
      submit: '提交申请'
    },
    messages: {
      submitSuccess: '特价申请已提交：{applicationNo}',
      rateDetailLoadFailed: '运价详情加载失败，请稍后重试'
    }
  },

  specialPriceApproval: {
    title: '特价申请BPM审批',
    back: '返回',
    empty: '暂无特价申请详情',
    missingRequest: '缺少有效的申请单 ID 或 BPM 流程实例 ID',
    loadFailed: '特价申请审批详情加载失败',
    noPriceItems: '暂无目标价明细',
    emptyRateFees: '暂无运价费用明细',
    emptySurchargeFees: '暂无附加费用明细',
    customerProfile: {
      title: '客户画像',
      partnerCustomer: '合作客户',
      empty: '暂无客户画像数据',
      loadFailed: '客户画像加载失败',
      totalOrderCount: '历史合作订单',
      recentSixMonthAmount: '近6月成交金额',
      paymentScore: '付款信誉评分',
      profitRate: '利润率',
      permissionVisible: '（有权限可见）',
      recentSpecialPriceApplications: '近6月特价申请',
      times: '次',
      approvedTimes: '通过 {count} 次',
      passRate: '通过率',
      historyRates: '历史成交运价',
      specialPriceHistory: '历史特价申请记录',
      emptyHistoryRates: '暂无历史成交运价',
      emptySpecialPriceHistory: '暂无历史特价申请记录',
      historyRatesLoadFailed: '历史成交运价加载失败',
      historyApplicationsLoadFailed: '历史特价申请记录加载失败',
      viewAll: '查看全部',
      totalRecords: '共 {count} 条',
      historyRateDrawerTitle: '历史成交运价',
      historyApplicationDrawerTitle: '历史特价申请记录',
      columns: {
        orderNo: '订单号',
        dealDate: '成交日期',
        applicationNo: '申请编号',
        applicationDate: '申请日期',
        route: '航线',
        rateType: '运价类型',
        unitPrice: '单价',
        quantity: '数量',
        amount: '含税成交金额',
        unit: '计费单位',
        targetAmount: '目标金额',
        status: '状态'
      },
      statuses: {
        pendingApproval: '待审批',
        approved: '已通过',
        rejected: '已拒绝',
        expired: '已过期',
        ordered: '已下单'
      }
    },
    aiDecision: {
      title: 'AI 辅助决策',
      unavailable: '辅助决策暂时不可用',
      unavailableDesc: '数据源确认后展示偏离度与风险提示',
      loadFailed: '辅助决策加载失败',
      empty: '暂无辅助决策数据',
      verdictApprove: '建议通过',
      verdictConditional: '建议加条件',
      verdictReject: '建议拒绝',
      creditScore: '客户信誉评分',
      scoreNoData: '暂无数据',
      scoreExcellent: '优秀',
      scoreGood: '良好',
      scoreAverage: '一般',
      scoreAttention: '待关注',
      priceDeviation: '价格偏离度分析',
      currentRate: '当前运价',
      noCalculablePriceDeviation: '原运价为空或为 0，无法计算偏离度',
      specialVsHistory: '特价 vs 原运价',
      specialVsMarket: '特价 vs 市场报价',
      applicationSummary: '历史特价申请摘要',
      total: '总申请',
      passed: '通过',
      passRate: '通过率',
      riskWarnings: '风险提示',
      riskUnavailable: '近3个月订单取消率暂不可用',
      noEffectiveOrders: '近3个月暂无进行中、已完成或已取消订单',
      noCancelledOrders: '近3个月有效订单 {total} 单，未发生取消',
      cancelledOrders: '近3个月有效订单 {total} 单，取消 {cancelled} 单，取消率 {rate}',
      noRisk: '暂无风险提示',
      referenceOnly: '辅助决策数据仅供审批参考，最终以审批人判断为准'
    },
    sections: {
      application: '申请信息',
      applicationFilled: '申请时填写的信息',
      applicationRemark: '申请备注',
      rate: '运价信息',
      basicInfo: '基本信息',
      routeInfo: '航线信息',
      carrierInfo: '船公司信息',
      freePeriod: '免费期限',
      validPeriod: '有效期',
      remarkInfo: '备注',
      rateFeeDetails: '运价费用明细',
      surchargeDetails: '附加费用明细',
      schedule: '指定船期',
      quantity: '数量',
      containerConfig: '箱型配置',
      lclPriceApplication: '拼箱目标价配置',
      airPriceApplication: '空运目标价配置',
      price: '目标价明细'
    },
    fields: {
      applicationNo: '申请编号',
      status: '申请状态',
      customer: '下单客户',
      applicant: '申请人',
      cargoReadyDate: '预计货好时间',
      cargoType: '货物类型',
      volumeCbm: '体积 (CBM)',
      weightTon: '重量 (TON)',
      specifySchedule: '是否指定船期',
      reason: '申请原因',
      remark: '备注',
      rejectedReason: '驳回原因',
      rateType: '运价类型',
      rateNo: '运价编号',
      validPeriod: '有效期',
      spaceStatus: '舱位状态',
      priceTrend: '价格趋势',
      carrier: '承运方',
      origin: '起运',
      destination: '目的',
      pol: '起运港(POL)',
      pod: '目的港(POD)',
      deliveryPlace: '交货地',
      directTransit: '直达/中转',
      supplier: '供应商',
      targetAmount: '申请总金额',
      vessel: '船名',
      voyage: '航次',
      laneCode: '航线代码',
      schedule: '船期',
      scheduleSource: '船期来源',
      contractNo: '合约号',
      detentionFreeDays: '免箱期(天)',
      demurrageFreeDays: '免堆期(天)',
      beginDate: '开始日期',
      endDate: '结束日期',
      overweightRemarks: '超重备注',
      receivingInstructions: '收货须知',
      oceanFreight: '海运费',
      baseRate: '基础运价'
    },
    columns: {
      itemName: '费用项',
      itemCode: '编码',
      containerType: '箱型',
      volumeCbm: '体积 (CBM)',
      weightTon: '重量 (TON)',
      densityLevel: '密度等级',
      pricingTier: '重量档位',
      currency: '币种',
      billingUnit: '计费单位',
      quantity: '数量',
      originalUnitPrice: '原单价',
      targetUnitPrice: '目标单价',
      targetContainerUnitPrice: '箱型目标单价',
      targetMinCharge: '目标最低收费',
      targetLclMinCharge: '目标最低一票',
      minCharge: '最低一票',
      wmPrice: 'W/M 目标单价',
      decreaseRate: '下降幅度',
      priceDelta: '差额/降幅',
      lineAmount: '小计',
      feeName: '费用名称',
      feeType: '费用类型',
      unit: '单位',
      unitPrice: '单价'
    },
    labels: {
      yes: '是',
      no: '否'
    },
    weekdays: {
      mon: '周一',
      tue: '周二',
      wed: '周三',
      thu: '周四',
      fri: '周五',
      sat: '周六',
      sun: '周日'
    },
    rateValues: {
      fclFreightType: {
        contract: '合约价',
        spot: 'SPOT电商价',
        peer: '同行价格'
      },
      lclRateType: {
        carrier: '船东价格',
        nvo: 'NVO同行价格',
        ecommerce: '电商运价',
        supplier: '供应商报价'
      },
      spaceStatus: {
        available: '畅接',
        normal: '正常',
        singleTicket: '单票申请',
        full: '爆舱',
        rejected: '不接'
      },
      priceTrend: {
        up: '价格上涨',
        down: '价格下调',
        stable: '价格稳定'
      },
      directTransit: {
        direct: '直达',
        transit: '中转',
        unspecified: '不指定'
      }
    },
    actions: {
      approve: '审批通过',
      reject: '驳回',
      retry: '重试'
    },
    status: {
      PENDING_APPROVAL: '待审批',
      APPROVED: '已通过',
      REJECTED: '已驳回',
      EXPIRED: '已过期',
      ORDERED: '已下单'
    }
  },

  // 字段标签
  fields: {
    validPeriod: '有效期',
    etd: 'ETD',
    eta: 'ETA',
    voyage: '航程',
    remarks: '备注',
    postalCode: '邮编',
    agent: '代理',
    supplier: '供应商',
    detailAddress: '详细地址',
    vesselVoyage: '船名航次',
    carrier: '船公司',
    freeDetentionDays: '免费用箱期',
    freeDemurrageDays: '免费用港期',
    vesselSchedule: '船期'
  },

  // 航线相关
  route: {
    directRoute: '直达航线',
    transitRoute: '中转航线',
    transitPorts: '中转港：{ports}',
    noRemarks: '暂无'
  },

  // 散杂货运价卡片
  bulkCard: {
    defaultCargoType: '散杂货',
    supplierFallback: '散杂',
    unitPerTon: '/吨',
    voyageDays: '{days}天',
    direct: '直达',
    transit: '中转',
    space: '舱位',
    validity: '有效期',
    periodTo: '至 {end}',
    periodFrom: '{begin} 起',
    spaceStatus: {
      smooth: '畅接',
      normal: '正常',
      singleApply: '单票申请',
      overbooked: '爆舱',
      notAccepting: '不接'
    }
  },

  // 滚装运价卡片
  roroCard: {
    defaultVehicleType: '车辆',
    unitPerVehicle: '/辆',
    voyageDays: '{days}天',
    direct: '直达',
    transit: '中转',
    sailing: '船期',
    validity: '有效期',
    space: '舱位',
    periodTo: '至 {end}',
    periodFrom: '{begin} 起',
    spaceStatus: {
      smooth: '畅接',
      normal: '正常',
      singleApply: '单票申请',
      overbooked: '爆舱',
      notAccepting: '不接'
    }
  },

  // 消息提示
  messages: {
    searchSuccess: '查询成功',
    searchFailed: '查询失败，请稍后重试',
    loadMoreSuccess: '加载更多成功',
    loadMoreFailed: '加载更多失败',
    noSearchCondition: '请输入查询条件',
    invalidDateRange: '日期范围无效',
    saveSearchHistoryFailed: '保存搜索历史失败',
    loadSearchHistoryFailed: '加载搜索历史失败',
    getPortNameFailed: '获取港口名称失败',
    clickTabToLoad: '点击{tab}标签页开始加载数据',
    portFallback: '港口{id}',
    noRemarks: '暂无备注'
  },

  // 搜索进度
  searchProgress: {
    searchingRates: '正在查询运价...',
    collapse: '收起',
    foundRates: '已找到 {count} 条运价',
    estRemaining: '预计剩余: {time}s',
    waiting: '等待中',
    searching: '查询中',
    completed: '完成',
    resultsCount: '{count} 条结果',
    noData: '暂无符合数据',
    foundCount: '已找到 {count} 条'
  }
}
